import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MODAL_CONTROLLER, MODAL_DATA, ModalController } from 'shared';
import { Device, DeviceDataPoint } from '../../interfaces/data-points';
import { InstallationConfigurationService } from '../../services/installation-configuration.service';
import { ModalComponent } from '../../../../../shared/src/lib/components/modal/modal.component';
import { ModalContentComponent } from '../../../../../shared/src/lib/components/modal-content/modal-content.component';
import { InfoContainerComponent } from '../../../../../shared/src/lib/components/info-container/info-container.component';
import { ModalSectionComponent } from '../../../../../shared/src/lib/components/modal-section/modal-section.component';
import { ModalSectionColumnComponent } from '../../../../../shared/src/lib/components/modal-section-column/modal-section-column.component';
import { InputLabelComponent } from '../../../../../shared/src/lib/components/input-label/input-label.component';
import { InputNumericFieldComponent } from '../../../../../shared/src/lib/components/input-numeric-field/input-numeric-field.component';
import { ModalButtonsComponent } from '../../../../../shared/src/lib/components/modal-buttons/modal-buttons.component';
import { ModalButtonComponent } from '../../../../../shared/src/lib/components/modal-button/modal-button.component';
import { TranslateModule } from '@ngx-translate/core';
import { AsyncPipe } from '@angular/common';

export interface SetpointModalInput {
  applicationId: string;
  installationId: string;
  temperatureSetPoint: DeviceDataPoint | null;
  max: number;
  min: number;
}

export interface SetpointModalResponse {
  temperatureSetPoint: number;
}

@Component({
    selector: 'app-setpoint-modal',
    templateUrl: './setpoint-modal.component.html',
    styleUrls: ['./setpoint-modal.component.scss'],
    imports: [
        ModalComponent,
        ModalContentComponent,
        FormsModule,
        ReactiveFormsModule,
        InfoContainerComponent,
        ModalSectionComponent,
        ModalSectionColumnComponent,
        InputLabelComponent,
        InputNumericFieldComponent,
        ModalButtonsComponent,
        ModalButtonComponent,
        TranslateModule,
        AsyncPipe,
    ]
})
export class SetpointModalComponent implements OnInit {
  public min: number;
  public max: number;
  public form: UntypedFormGroup;
  public setpoint: number;
  public isValid$: Observable<boolean>;

  constructor(
    @Inject(MODAL_DATA) public data: SetpointModalInput,
    @Inject(MODAL_CONTROLLER) private controller: ModalController<void>,
    private installationConfigurationService: InstallationConfigurationService
  ) {}

  ngOnInit(): void {
    this.min = this.data.min;
    this.max = this.data.max;
    this.setpoint = parseFloat(Number(this.data.temperatureSetPoint?.value).toFixed(1));

    this.form = new UntypedFormGroup({
      temperatureSetpoint: new UntypedFormControl(this.setpoint, [Validators.min(this.min), Validators.max(this.max)]),
    });

    this.isValid$ = this.form.valueChanges.pipe(
      map((value) => {
        return this.form.valid;
      })
    );
  }

  close() {
    this.controller.dismiss();
  }

  save() {
    this.installationConfigurationService.updateSetPoint(
      this.data.installationId,
      this.data.applicationId,
      this.form.controls.temperatureSetpoint.value
    );
    this.controller.complete();
  }
}
